
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { TimeEntry } from "@/types/time-entry";

interface UserTimeEntry extends TimeEntry {
  user_full_name: string;
  hourly_rate: number;
}

export function useUserTimeEntries(userId: string, enabled: boolean) {
  const { data: timeEntries, isLoading } = useQuery({
    queryKey: ["user-time-entries", userId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_user_time_entries", {
        p_user_id: userId,
      });
      if (error) throw error;
      return data as UserTimeEntry[];
    },
    enabled,
  });

  return {
    timeEntries,
    isLoading,
  };
}

export type { UserTimeEntry };
